__turbopack_context__.v({
  "section-block": "MarketingSectionBlockDesktop-module-scss-module__4QQy6q__section-block",
  "section-links": "MarketingSectionBlockDesktop-module-scss-module__4QQy6q__section-links",
  "section-title": "MarketingSectionBlockDesktop-module-scss-module__4QQy6q__section-title",
});
